import { getSourcePathAccessor } from "../utils";
import { DIDI as defaultOptions } from "./defaultOptionsForComputation";
import sma from "./sma";

const isValidNumber = (value) =>
  typeof value === "number" && Number.isFinite(value);

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) return [];

    const { highPeriod, midPeriod, lowPeriod, sourcePath } = options;

    const source = getSourcePathAccessor(sourcePath);
    const highMA = sma().options({
      windowSize: Math.max(1, highPeriod || 1),
      sourcePath,
    });
    const midMA = sma().options({
      windowSize: Math.max(1, midPeriod || 1),
      sourcePath,
    });
    const lowMA = sma().options({
      windowSize: Math.max(1, lowPeriod || 1),
      sourcePath,
    });

    const highValues = highMA(data);
    const midValues = midMA(data);
    const lowValues = lowMA(data);

    return data.map((datum, index) => {
      const price = source(datum);
      if (!isValidNumber(price)) return undefined;

      const high = highValues[index];
      const mid = midValues[index];
      const low = lowValues[index];

      if (!isValidNumber(high) || !isValidNumber(mid) || !isValidNumber(low)) {
        return undefined;
      }

      return {
        short: high - mid,
        long: low - mid,
      };
    });
  }

  calculator.undefinedLength = function () {
    const { highPeriod, midPeriod, lowPeriod } = options;
    return Math.max(highPeriod || 1, midPeriod || 1, lowPeriod || 1) - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
